import React, {useRef, useCallback, useState} from 'react'
import './MobileMenu.scss'

import {motion, useCycle} from 'framer-motion'
import {useDimensions} from '../../../utils/use-dimensions'

import {MenuToggle} from './MenuToggle'
import {Navigation} from './Navigation'


const sidebar = {
  open: (height = 1000) => ({
    x: '0px',
    transition: {
      type: 'spring',
      stiffness: 800,
      velocity: 80,
      damping: 100,
      restDelta: 2
    }
  }),
  closed: {
    x: '+300px',
    transition: {
      delay: 0.5,
      type: 'spring',
      stiffness: 800,
      damping: 70
    }
  }
}

const useMobileMenu = () => {
  const [isOpen, toggleOpen] = useState(false)
  const closeAfterScroll = useCallback(() => toggleOpen(false), [])

  return {isOpen, toggleOpen, closeAfterScroll}
}

const MobileMenu = (props) => {
  const {menus, isSubPage} = props
  const containerRef = useRef(null)
  const {height} = useDimensions(containerRef)
  const {isOpen, toggleOpen, closeAfterScroll} = useMobileMenu()

  return (
<div className='mobileMenu'>
    <motion.nav
      initial={false}
      animate={isOpen ? 'open' : 'closed'}
      custom={height}
      ref={containerRef}
    >
      <motion.div className='mobileMenu__background' variants={sidebar} />
      <Navigation menus={menus} toggle={() => toggleOpen(!isOpen)} closeAfterScroll={closeAfterScroll} isSubPage={isSubPage} />
      <MenuToggle toggle={() => toggleOpen(!isOpen)} />
    </motion.nav>
</div>
  )
}

export default MobileMenu
